import React, { useEffect, useState } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Button } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";

import axios from "axios";
import axiosInstance from "../../Config/axios";
import { API_URLS } from "../../Config/API_URLS";

export default function Plan() {
  const [data, setData] = useState([]);
  const { variant_id } = useParams();
  const GetSubscriptionList = () => {
    axiosInstance
      .post(API_URLS.subscriptionList)
      .then((response) => {
        setData(response?.data?.brand_data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    GetSubscriptionList();
  }, []);

  console.log("GetSubscriptionList", data);
  const navigate = useNavigate();

  return (
    <>
      <div className="pt-28 px-3 ">
        <div className="text-left ">
          <ArrowBackIcon onClick={() => navigate("/save")} />
        </div>

        <div className="flex justify-center  p-2 gap-10  bg-white rounded-lg ">
          <div className="flex-col justify-center w-1/3">
            <img
              src="https://m.media-amazon.com/images/I/81pPi3qNECL._AC_SR350,526_FMwebp_QL65_.jpg"
              alt=""
            />
          </div>

          <div className="flex-col gap-5 w-2/3">
            <p className="pt-6">Delivered on Mar 10</p>
            <p className="">₹ 61 </p>
            <span>₹ 91.00 OFF</span>
            <p className="text-gray-500">(inclusive all taxes)</p>
            <div className="px-3 py-2">
              <p className="border  border-green-400 bg-green-300 rounded-lg">
                Subscribe to save 8%
              </p>
            </div>
          </div>
        </div>

        <p className="text-red-500 py-4">
          *Price of products on subscription may change as per market changes
        </p>
        <p className="font-bold text-lg text-left py-3">Select Your Plan</p>
        <div className="flex gap-10 py-3 justify-center">
          {data?.map((item) => {
            return (
              <Button
                variant="contained"
                onClick={() => {
                  item.id == 1 &&
                    navigate(`/calendar/${item.id}/${variant_id}`);
                  item.id === 2 && navigate(`/weekly/${item.id}/${variant_id}`);
                  item.id === 3 &&
                    navigate(`/monthly/${item.id}/${variant_id}`);
                }}
              >
                {item?.subscription_name}
              </Button>
            );
          })}
        </div>
        {/* <div className="py-2">
          <Button variant="contained">Alternative Days</Button>
        </div> */}
      </div>
    </>
  );
}
